<template>
    <div class="auth-wrapper middle-aligner">
        <div class="inner">
            <div class="card card-auth with-shadow">
                <h2 class="auth-heading">
                    Reset password
                    <span> Please reset your account password. </span>
                </h2>
                <div class="auth-body has-icon">
                    <b-form @submit.stop.prevent="onSubmit()">
                        <b-form-group
                            id="new-reset-password-input"
                            label="NEW PASSWORD"
                            label-for="new-reset-password"
                        >
                            <b-form-input
                                id="new-reset-password-field"
                                ref="password"
                                v-model="formData.password"
                                v-validate="{
                                    required: true,
                                    max: 20,
                                    min: 6,
                                    regex: /^(?=^.{6,20}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&amp;*_=+-])(?!.*\s).*$/,
                                }"
                                type="password"
                                placeholder="Enter your new password"
                                data-vv-name="password"
                                :class="{
                                    'is-invalid': errors.has('password'),
                                }"
                            ></b-form-input>
                            <div
                                class="system-user-warning password-validation"
                            >
                                <i
                                    v-b-tooltip.hover
                                    class="icon-error_outline"
                                    placement="lefttop"
                                    title=" 
                                    - Password must be between 6-20 characters.
                                    - Password must contain at least 1 uppercase letter, 1 lowercase. letter, 1 numeric character and at least 1 symbol.
                                    - The symbols allowed are !@#$%^&amp;*_=+        
                                    - Last 10 passwords cannot be reused."
                                ></i>
                            </div>
                        </b-form-group>
                        <b-form-group
                            id="confirm-password-input"
                            label="CONFIRM PASSWORD"
                            label-for="confirm-password"
                        >
                            <b-form-input
                                id="confirm-reset-password-field"
                                v-model="formData.passwordConfirmation"
                                v-validate="{
                                    required: true,
                                    confirmed: 'password',
                                    max: 20,
                                    min: 6,
                                    regex: /^(?=^.{6,20}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&amp;*_=+-])(?!.*\s).*$/,
                                }"
                                type="password"
                                placeholder="Re-enter your new password"
                                data-vv-name="password confirmation"
                                :class="{
                                    'is-invalid': errors.has(
                                        'password confirmation'
                                    ),
                                }"
                            ></b-form-input>
                        </b-form-group>
                        <base-button
                            btn-label="RESET"
                            btn-type="submit"
                            btn-variant="primary"
                            :disabled="loading"
                            :class="loading ? 'disabled' : ''"
                        ></base-button>
                        <base-toast></base-toast>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {}, // End of Component > components
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            formData: this.initializeFormData(),
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading']),
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        if (this.$route.params && this.$route.params.token) {
            this.formData.token = this.$route.params.token
        }
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        initializeFormData() {
            return {
                password: '',
                passwordConfirmation: '',
                token: null,
            }
        }, // End of initializeFormData() methods

        async onSubmit() {
            const result = await this.$validator.validateAll()

            if (result) {
                try {
                    // authResetPassword action in auth store
                    let response = await this.$store.dispatch(
                        'authResetPassword',
                        this.formData
                    )
                    if (response) {
                        this.$router.push({ name: 'login-page' })
                        this.clearFormData()
                    }

                    // Clearing formData fields on submit
                } catch (error) {
                    this.$store.commit('setError', this.errors.all()[0])
                    console.log(error, 'There is an error on reset password')
                }
            }
        }, // End of onSubmit() method

        clearFormData() {
            this.$validator.reset()
            Object.assign(this.formData, this.initializeFormData())
        }, // End of clearFormData() method
    }, // End of Component > mounted
} // End of export default
</script>
